import {
  GET_SIGNIN_RESOURCES,
  CREATE_SIGNIN_RESOURCES,
  DELETE_SIGNIN_RESOURCE,
  EDIT_SIGNIN_RESOURCE,
} from 'actions/actionTypes';
import { ISigninResourcesState, ISigninResource } from 'types';

interface ActionType {
  type:
    | 'GET_SIGNIN_RESOURCES'
    | 'CREATE_SIGNIN_RESOURCES'
    | 'DELETE_SIGNIN_RESOURCE'
    | 'EDIT_SIGNIN_RESOURCE'
    | 'DRESOURCE_ERROR';
  payload: {
    unitId: number;
    resources: ISigninResource[];
    created: ISigninResource;
    resourceId?: number;
    error?: string | null;
    updated?: ISigninResource;
  };
}

const initialState: ISigninResourcesState = {
  units: {},
};

const signinResources = (
  state = initialState,
  action: ActionType
): ISigninResourcesState => {
  switch (action.type) {
    case CREATE_SIGNIN_RESOURCES: {
      const { unitId, created } = action.payload;
      const { units } = state;

      units[unitId]?.push(created);
      units[unitId]?.sort((a, b) => a.id - b.id);

      return {
        ...state,
      };
    }
    case GET_SIGNIN_RESOURCES: {
      const { unitId, resources } = action.payload;
      const { units } = state;

      const updated = {
        ...units,
        [unitId]: resources?.sort((a, b) => a.id - b.id),
      };

      return {
        units: updated,
      };
    }
    case EDIT_SIGNIN_RESOURCE: {
      const { unitId, updated } = action.payload;
      const { units } = state;
      const res = units[unitId];

      if (updated && res) {
        const index = res.findIndex((r) => r.id === updated.id);
        res.splice(index, 1, updated);
      }

      return {
        ...state,
      };
    }
    case DELETE_SIGNIN_RESOURCE: {
      const { unitId, resourceId } = action.payload;
      const { units } = state;

      const removed = units[unitId].filter((r) => r.id !== resourceId);
      const updated = { ...units, [unitId]: removed };

      return {
        units: updated,
      };
    }
    default:
      return state;
  }
};

export default signinResources;
